import React from 'react';
import PropTypes from 'prop-types';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Input from '../input/Input';
import TextArea from '../textArea/TextArea';
import Select from '../select/Select';
import Button from '../button/Button';
import * as classes from './SmeLendingForm.module.scss';

const formatAmount = (amount) =>
  new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);

const createValidator = (config) => {
  const { minimumLendingAmount, maximumLendingAmount, productLimitName } = config;

  return yup.object().shape({
    requestedLendingAmount: yup
      .number()
      .typeError('Please enter a number')
      .required('Please enter a number')
      .min(minimumLendingAmount, `The minimum ${productLimitName} is ${formatAmount(minimumLendingAmount)}`)
      .max(maximumLendingAmount, `The maximum ${productLimitName} is ${formatAmount(maximumLendingAmount)}`),
    purpose: yup.string().required('This field is required').max(256, 'Please enter fewer than 256 characters'),
    ...(config.showTermField
      ? {
          termInMonths: yup.number().min(1, 'The term must be greater than 1 month')
        }
      : {})
  });
};

function Step3({ config, onSubmit }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control
  } = useForm({
    mode: 'onTouched',
    resolver: yupResolver(createValidator(config)),
    shouldUnregister: true
  });

  return (
    <form onSubmit={handleSubmit((data) => onSubmit(data, 4))} className={classes.step}>
      <Input
        id="requestedLendingAmount"
        type="number"
        prefix="£"
        label={config.lendingAmountLabel}
        error={errors.requestedLendingAmount}
        {...register('requestedLendingAmount')}
      />

      <TextArea
        id="purpose"
        label={`Please tell us what the ${config.productName} will be used for and how it will support your business activity or growth`}
        error={errors.purpose}
        {...register('purpose')}
      />

      {config.showTermField ? (
        <Controller
          control={control}
          name="termInMonths"
          defaultValue={12}
          render={({ field }) => (
            <Select
              value={field.value}
              onChange={field.onChange}
              label="What is the proposed term of the facility?"
              error={errors.termInMonths}
              options={{
                12: '1 year',
                24: '2 years',
                36: '3 years',
                48: '4 years',
                60: '5 years',
                72: '6 years'
              }}
            />
          )}
        />
      ) : null}

      <Button variant="secondary">Next</Button>
    </form>
  );
}
Step3.propTypes = {
  config: PropTypes.object,
  onSubmit: PropTypes.func
};

export default Step3;
